<template>
  <div>
    <div class="navbar navbar-fixed-top">
      <div class="navbar-inner">
        <div class="container-fluid">
          <a class="btn btn-navbar" data-toggle="collapse" data-target=".nav-collapse">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </a>
          <a class="brand" href="/#/AlbumCatalog">Panolib</a>
          <div class="nav-collapse">
            <ul class="nav">
              <li class="active"><a href="/#/AlbumCatalog">カテゴリ一覧</a></li>
              <li><a href="/#/UserKanri">ユーザー管理</a></li>
              <li v-if="this.$store.state.myapp.kengen === '1' || this.$store.state.myapp.kengen === '2'"><a href="/#/Riyo">利用状況一覧</a></li>
              <li v-if="this.$store.state.myapp.kengen === '1'"><a href="/#/Contract">契約情報管理</a></li>
            </ul>
            <p class="navbar-text pull-right"><a href="/#/Top">ログアウト</a></p>
          </div>
        </div>
      </div>
    </div>
    <div class="nav" style="height: 9%">
      <ul style="margin: 0">
        <li style="display: inline">
          <span>現在位置：</span>
        </li>
        <li style="display: inline">
          <a href="/#/AlbumCatalog">H O M E</a>
        </li>
          >
        <li style="display: inline">
          <a  class="nowPage" style="text-decoration: none; color: black">カテゴリ一覧</a>
        </li>
      </ul>
    </div>
    <div class="page-header">
      <h1>カテゴリ一覧</h1>
      <br />
      <a class="btn btn-primary" href="/#/AlbumCatalogAdd">カテゴリ作成</a>
    </div>
    <table class="table table-striped table-bordered">
      <thead>
        <tr >
          <th>カテゴリ名</th>
          <th>作成者</th>
          <th width="150">作成日時</th>
          <th width="150">更新日時</th>
          <th width="100">アルバム数</th>
          <th width="100">画像数</th>
          <th width="220" style="text-align: center;">操作</th>
        </tr>
      </thead>
      <tbody>
          <tr v-for="albumCatalog in this.$store.state.myapp.albumCatalogs" :key="albumCatalog" @click="getId(albumCatalog.id, albumCatalog.name)">
          <td>{{albumCatalog.name}}</td>
          <td>{{albumCatalog.userId}}</td>
          <td>{{albumCatalog.createTimeDisplay}}</td>
          <td>{{albumCatalog.updateTimeDisplay}}</td>
          <td>{{albumCatalog.albumNum}}</td>
          <td>{{albumCatalog.picNum}}</td>
          <td style="min-width:220px;">
            <div class="btn-group" style="width:220px; margin: 0 auto;">
              <a class="btn" href="/#/Album">アルバム一覧</a>
              <a class="btn" href="/#/AlbumCatalogEdit">編&nbsp;&nbsp;&nbsp;集</a>
              <a class="btn" @click="remove(albumCatalog.id)">削&nbsp;&nbsp;&nbsp;除</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {albumCatalogViewModel} from '@/view-model/AlbumCatalog'
import {ACTIONS} from '@/store/action-types'

export default {
  mixins: [albumCatalogViewModel],
  methods: {
  // エラーがある場合、ポップアップ画面を表示する。
    toDisclosureStatement () {
      if (this.$root.isMobile.any === true) {
        this.$store.dispatch(ACTIONS.DOCUMENT_OPEN, {name: 'DisclosureStatementSp', showScrollBtn: true})
      } else {
        this.$store.dispatch(ACTIONS.DOCUMENT_OPEN, {name: 'DisclosureStatement', showScrollBtn: true})
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/AlbumCatalog.vue